import React from 'react';
import { CircularProgress, Alert } from '@mui/material';

const StatsCard = ({ title, loading, error, children }) => {
  if (loading) {
    return (
      <div className="stats-card">
        <h2>{title}</h2>
        <div style={{ textAlign: 'center', padding: '2rem' }}>
          <CircularProgress />
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="stats-card">
        <h2>{title}</h2>
        <Alert severity="error" sx={{ mb: 2 }}>
          {error}
        </Alert>
      </div>
    );
  }

  return (
    <div className="stats-card">
      <h2>{title}</h2>
      {children}
    </div>
  );
};

export default StatsCard; 